import { useTranslation } from '@crew/modules/i18n'
import { CrewButton } from 'components/elements/crewButton/crewButton'
import { memo, useCallback } from 'react'
import { useEventDetailRelatedInfoListContext } from '../../eventDetailRelatedInfoList'
import { useShowApiErrors } from 'hooks/useShowApiErrors'
import { useEventDetailRelatedInfoListToolbar } from './useEventDetailRelatedInfoListToolbar'

export const EventDetailRelatedInfoListToolbar = memo(() => {
  const { t } = useTranslation()
  const [showApiErrors] = useShowApiErrors()

  const { generateEventRelatedInfo, isLoadingGenerateRelatedMutation } =
    useEventDetailRelatedInfoListToolbar()

  const { displayState, setDisplayState } =
    useEventDetailRelatedInfoListContext()

  // 表示制御
  const showRelatedInfoTable = displayState === 'relatedInfo'

  // 「AIで関連情報を検索する」ボタンをクリックしたときの処理
  const handleFindRelatedInfoButtonClick = useCallback(async () => {
    try {
      // 表示を検索中に切り替え
      setDisplayState('searching')
      // 生成APIを呼び出し
      await generateEventRelatedInfo()
    } catch (err) {
      setDisplayState('relatedInfo')
      showApiErrors(err)
    }
  }, [generateEventRelatedInfo, setDisplayState, showApiErrors])

  return (
    <div className="flex justify-between items-center p-2.5">
      {/* 「AIで関連情報を探す」ボタン */}
      {showRelatedInfoTable && (
        <CrewButton
          id="event-detail-related-info-list-toolbar-find-related-info-button"
          type="primary"
          className="ml-auto"
          text={t('action.findRelatedInformationWithAI')}
          onClick={handleFindRelatedInfoButtonClick}
          disabled={isLoadingGenerateRelatedMutation}
        />
      )}
    </div>
  )
})
